import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "./authSlice";

const baseURL = import.meta.env.VITE_API_BASE_URL;

// ---------------------------------FETCH CATEGORY FOR SEARCHING FUNCTIONALITY--------------
export const fetchCategory = createAsyncThunk(
  "meal-gallery/fetchCategory",
  async (_, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.get(
        "/admin/get-meal-image-category-master"
      );
      // console.log("The res for cat is :", res.data);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.res?.data || "Error fetching Category");
    }
  }
);

// --------------------------------FETCH COUNTRY CODE -----------------
export const fetchCountry = createAsyncThunk(
  "meal-gallery/fetchCountry",
  async (_, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.get("/get-country");
      //   console.log("The res for country is :", res.data);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.res?.data || "Error fetching country");
    }
  }
);

// ---------------------------------------FETCH MEAL LIST------------------------------------------------
export const fetchMealDetail = createAsyncThunk(
  "meal-detail/fetchMealDetail",
  async (
    { page = 1, country_id = "", category_id = "" },
    { rejectWithValue }
  ) => {
    try {
      const res = await axiosInstance.get(
        `/admin/meal-gallery/list-image?page=${page}&country_id=${country_id}&category_master_id=${category_id}`
      );
      return res.data;
    } catch (err) {
      return rejectWithValue(err.res?.data || "Error fetching meal details");
    }
  }
);

// ------------------------------------FETCH PRIORITY LIST -------------------------
export const fetchMealPriority = createAsyncThunk(
  "meal-gallery/fetchMealPriority",
  async (category_master_id, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.post(
        "/admin/meal-gallery/get-priority",
        { category_master_id }
      );

      return res.data; // { data: [...] }
    } catch (err) {
      return rejectWithValue(
        err.response?.data || "Error fetching meal priority"
      );
    }
  }
);

// ---------------------------------GET MEAL DETAIL BY ID ---------------------------
export const getMealDetailById = createAsyncThunk(
  "meal-detail/getMealDetailById",
  async (meal_image_gallery_id, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.post(
        "/admin/meal-gallery/get-image",
        { meal_image_gallery_id }
      );
      // console.log("The all res for getting meal by id is :", res.data.data);
      // console.log("res of getting  country id:", res.data.data.country_id);
      // console.log(
      //   "res of getting category id :",
      //   res.data.data.category_master_id
      // );
      // console.log("res of getting name :", res.data.data.name);
      // console.log("res of getting  image:", res.data.data.image);
      // console.log("res of getting  status:", res.data.data.status);
      // console.log("res of getting  priority:", res.data.data.priority);

      return res.data.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data || "Error while getting meal details"
      );
    }
  }
);

// -----------------------------------ADD IMAGE --------------------------------

export const addMealimg = createAsyncThunk(
  "meal-image/addMealimg",
  async (formInputs, { rejectWithValue }) => {
    try {
      const formData = new FormData();

      if (formInputs.meal_image_gallery_id) {
        formData.append(
          "meal_image_gallery_id",
          formInputs.meal_image_gallery_id
        );
      }

      formData.append(
        "category_master_id",
        String(formInputs.category_master_id)
      );
      formData.append("country_id", String(formInputs.country_id));
      formData.append("name", formInputs.name);
      formData.append("priority", String(formInputs.priority));

      // ⭐ NEW IMAGE LOGIC
      if (formInputs.image instanceof File) {
        // user reuploaded a new image
        formData.append("image", formInputs.image);
      } else {
        // user did NOT upload new image → send null (backend keeps old image)
        formData.append("image", "");
      }

      const res = await axiosInstance.post(
        "/admin/meal-gallery/add-or-update-image",
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      return res.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data || "Error while adding/updating image"
      );
    }
  }
);

// ---------------------Delete meal details -------------------------
export const deleteMealdetail = createAsyncThunk(
  "meal-details/deleteMealdetail",
  async (meal_image_gallery_id, { rejectWithValue }) => {
    try {
      await axiosInstance.post("/admin/meal-gallery/delete-image", {
        meal_image_gallery_id: meal_image_gallery_id,
        is_confirmed: 1,
      });
      return meal_image_gallery_id; // <-- return ID for reducer
    } catch (err) {
      return rejectWithValue(
        err.response?.data || "Error deleting meal details"
      );
    }
  }
);

// ---------------------Update status -----------------------------
export const statusupdatemealdetail = createAsyncThunk(
  "meal-detail/statusupdatemealdetail",
  async ({ meal_image_gallery_id }, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.post(
        "/admin/meal-gallery/image-status-update",
        {
          meal_image_gallery_id: meal_image_gallery_id,
          is_confirmed: 1,
        }
      );
      // console.log("The api data for status is :", res.data)
      return {
        meal_image_gallery_id: res.data.data.meal_image_gallery_id,
        status: res.data.data.new_status,
      };
    } catch (err) {
      return rejectWithValue(err.res?.data || "Error while updating status");
    }
  }
);

const gallerySlice = createSlice({
  name: "gallery",
  initialState: {
    List: [],
    categoryList: [],
    countryList: [],
    mealList: [],
    mealListById: [],
    priorityList: [],
    addImage: null,
    deleteDetail: null,
    loading: false,
    error: null,
    currentPage: 1,
    totalPages: 1,
  },
  reducers: {},
  extraReducers: (builder) => {
    // For category
    builder
      .addCase(fetchCategory.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCategory.fulfilled, (state, action) => {
        state.loading = false;
        state.categoryList = action.payload.data || [];
      })

      .addCase(fetchCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      //   For country
      .addCase(fetchCountry.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCountry.fulfilled, (state, action) => {
        state.loading = false;
        state.countryList = action.payload.data || [];
      })
      .addCase(fetchCountry.rejected, (state, action) => {
        (state.loading = false), (state.error = action.payload);
      })

      //   For meal-details
      .addCase(fetchMealDetail.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchMealDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.mealList = action.payload.data.mealImageGalleryData || [];
        state.currentPage = action.payload.data.current_page || 1;
        state.totalPages = action.payload.data.total_pages || 1;
      })

      .addCase(fetchMealDetail.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      //   For meal priority
      .addCase(fetchMealPriority.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchMealPriority.fulfilled, (state, action) => {
        state.loading = false;
        state.priorityList = action.payload.data?.priorities || [];
      })
      .addCase(fetchMealPriority.rejected, (state, action) => {
        (state.loading = false), (state.error = action.payload);
      })

      //    For adding image
      .addCase(addMealimg.pending, (state) => {
        state.loading = true;
      })
      .addCase(addMealimg.fulfilled, (state, action) => {
        state.loading = false;
        const newImage = action.payload.data;

        // Update mealList properly
        const index = state.mealList.findIndex(
          (item) => item.id === newImage?.id
        );

        if (index !== -1) {
          // Editing existing image → replace
          state.mealList[index] = newImage;
        } else {
          // Adding new image → push
          state.mealList.unshift(newImage);
        }

        state.addImage = newImage;
      })

      .addCase(addMealimg.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      //   Deleting details
      .addCase(deleteMealdetail.fulfilled, (state, action) => {
        state.mealList = state.mealList.filter(
          (item) => item.id !== action.payload
        );
      })
      //   Status update
      .addCase(statusupdatemealdetail.fulfilled, (state, action) => {
        const index = state.mealList.findIndex(
          (item) => item.id === action.payload.meal_image_gallery_id
        );
        if (index !== -1) {
          state.mealList[index].status = action.payload.status;
        }
      })
      // Get meal list by id
      .addCase(getMealDetailById.pending, (state) => {
        state.loading = true;
      })
      .addCase(getMealDetailById.fulfilled, (state, action) => {
        state.loading = false;
        state.mealListById = action.payload;
      })
      .addCase(getMealDetailById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default gallerySlice.reducer;
